export default __webpack_public_path__ + "assets/images/7ab0eebd6bc31979417a241751c5949c.svg";